import i18n from 'i18n-literally'
import { createSelector } from 'redux-bundler'

import ms from 'milliseconds'

import createListBundle, { defaultInitialState, defaultListActions } from '~/src/Lib/createListBundle'
import { EMPTY_OBJECT, getDateTime } from '~/src/Lib/Utils'
import { Harvest } from '~/src/Store/Schemas'

import { PHASE_TYPES } from '../constants'

export const HARVEST_STATE_FILTERS = [
  {
    get label() {
      return i18n`Currently Growing`
    },
    value: 'CURRENT',
  },
  {
    get label() {
      return i18n`Already Harvested`
    },
    value: 'HARVESTED',
  },
]

const initialState = {
  ...defaultInitialState,
  filter: 'CURRENT',
  sort: ['name', 'asc'],
  page: 1,
  cultivar: undefined,
  phase: null,
  room: undefined,
  recipe: undefined,
}

const queryKeyMap = {
  filter: 'currentFilter',
  sort: 'ordering',
  recipe: 'sourceRecipeId',
}

const queryValueMap = {
  end: end => end && getDateTime(end).toUTC().toISO(),
  start: start => start && getDateTime(start).toUTC().toISO(),
}

const queryBuilder = params =>
  Object.keys(params).reduce(
    (acc, key) =>
      params[key]
        ? {
            ...acc,
            [queryKeyMap[key] ?? key]: key in queryValueMap ? queryValueMap[key](params[key]) : params[key],
          }
        : acc,
    params.filter === initialState.filter ? { pagination: 0 } : EMPTY_OBJECT,
  )

const initialBundle = createListBundle({
  entityName: 'harvest',
  actions: [...defaultListActions, 'set_cultivar', 'set_phase', 'set_room', 'set_recipe'],
  initialState,
  permissions: { keys: ['view_harvest'] },
  schema: Harvest,
  retryAfter: ms.seconds(5),
  staleAfter: ms.minutes(15),
  fetchHandler: ({ apiFetch, params }) => apiFetch('/harvests/', params),
  transformParams: queryBuilder,
})

export default {
  ...initialBundle,
  reactUpdateFilter: createSelector('selectHarvestListParams', ({ filter }) => {
    const validFilters = [
      {
        label: i18n`All Harvest Groups`,
        value: 'ALL',
      },
      ...HARVEST_STATE_FILTERS,
    ]
    const haveValidFilter = PHASE_TYPES.includes(filter) || validFilters.find(({ value }) => value === filter)
    if (!haveValidFilter) {
      return {
        actionCreator: 'doHarvestListSetParams',
        args: [{ filter: HARVEST_STATE_FILTERS[0].value }],
      }
    }
    return undefined
  }),
}
